import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { SITE } from "../data/site";

const PrivacyPolicy = () => (
  <>
    <Seo
      title="Privacy Policy | Studio Legale Avv. Manfredi Bruno, Palermo"
      description="Informativa sul trattamento dei dati personali del sito dello Studio Legale Avv. Manfredi Bruno di Palermo, ai sensi del Regolamento (UE) 2016/679 (GDPR)."
      path="/privacy-policy"
    />
    <PageHero kicker="Documenti legali" title="Privacy Policy" breadcrumb="Privacy Policy" />

    <section className="bg-white py-14 sm:py-20">
      <div className="container-site legal-prose max-w-3xl" data-testid="privacy-content">
        <p>
          La presente informativa descrive le modalità di trattamento dei dati personali
          degli utenti che visitano questo sito web, ai sensi del Regolamento (UE)
          2016/679 ("GDPR") e del D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018.
        </p>

        <h2>1. Titolare del trattamento</h2>
        <p>
          Il titolare del trattamento è l'<strong>Avv. Manfredi Bruno</strong>, con studio
          in {SITE.address}. Email: <strong>{SITE.email}</strong> — Telefono:{" "}
          <strong>{SITE.phone}</strong>.
        </p>

        <h2>2. Dati trattati e finalità</h2>
        <p>Attraverso il sito possono essere trattate le seguenti categorie di dati:</p>
        <ul>
          <li>
            <strong>Dati forniti volontariamente tramite il modulo di contatto</strong>{" "}
            (nome, indirizzo email, numero di telefono, argomento e testo del messaggio),
            utilizzati esclusivamente per ricontattare l'interessato, gestire la richiesta
            e fissare eventuali appuntamenti.
          </li>
          <li>
            <strong>Dati di navigazione</strong>: i sistemi informatici acquisiscono, nel
            normale funzionamento, alcuni dati tecnici (indirizzi IP, orari di accesso,
            pagine visitate) necessari al funzionamento e alla sicurezza del sito.
          </li>
          <li>
            <strong>Cookie</strong>: per dettagli si rinvia alla Cookie Policy.
          </li>
        </ul>

        <h2>3. Base giuridica del trattamento</h2>
        <p>
          Il trattamento dei dati forniti tramite il modulo di contatto si fonda sul
          consenso dell'interessato (art. 6, par. 1, lett. a GDPR), espresso mediante
          l'apposita casella di selezione, e sull'esecuzione di misure precontrattuali
          richieste dall'interessato (art. 6, par. 1, lett. b GDPR).
        </p>

        <h2>4. Modalità del trattamento e conservazione</h2>
        <p>
          I dati sono trattati con strumenti informatici e con misure di sicurezza adeguate
          a garantirne riservatezza e integrità. I dati inviati tramite il modulo di
          contatto sono conservati per il tempo necessario a gestire la richiesta e,
          ove il rapporto prosegua, secondo i termini previsti per la clientela dello
          studio e dagli obblighi di legge.
        </p>

        <h2>5. Comunicazione dei dati</h2>
        <p>
          I dati non sono diffusi né ceduti a terzi. Possono essere trattati da fornitori
          di servizi tecnici (hosting, gestione email) che operano nel rispetto del GDPR
          in qualità di responsabili del trattamento, ove nominati.
        </p>

        <h2>6. Diritti dell'interessato</h2>
        <p>
          L'interessato può esercitare in qualsiasi momento i diritti previsti dagli artt.
          15-22 GDPR: accesso, rettifica, cancellazione, limitazione, portabilità,
          opposizione e revoca del consenso, scrivendo a{" "}
          <strong>{SITE.email}</strong>. È inoltre possibile proporre reclamo al Garante
          per la protezione dei dati personali.
        </p>

        <h2>7. Natura del conferimento</h2>
        <p>
          Il conferimento dei dati tramite il modulo di contatto è facoltativo; il mancato
          conferimento impedisce però allo studio di ricontattare l'interessato.
        </p>

        <h2>8. Modifiche alla presente informativa</h2>
        <p>
          Il titolare può aggiornare la presente informativa; la versione vigente è quella
          pubblicata su questa pagina. Ultimo aggiornamento: luglio 2026.
        </p>
      </div>
    </section>
  </>
);

export default PrivacyPolicy;
